import {useState, useEffect, useContext} from 'react'
import {Input, Select, Space} from 'antd'
import {isFunction} from 'lodash-es'
import callContext from '@/pages/crm/callCenter/callManage/callManageContext'

const {Option} = Select
export const InputItem = props => {
  const {updateCallManageState, callManageState} = useContext(callContext)
  const {callFormData, clueId, refreshList} = callManageState || {}
  const placeholderList = {call: '请输入手机号码拨打', search: '手机号码、线索ID查询'}
  const buttonText = {call: '呼叫', search: '搜索'}
  const {onTypeChange, onChange, onSearch, onCall, callDisabled} = props
  const [type, setType] = useState('search')
  const [value, setValue] = useState('')
  useEffect(() => {
    if (clueId) {
      setValue(clueId)
      updateCallManageState({
        callFormData: {...callFormData, key: clueId},
        currentPage: 1,
        refreshList: !refreshList,
      })
    }
  }, [clueId])
  const selectBefore = (
    <Select
      value={type}
      onChange={e => {
        setType(e)
        isFunction(onTypeChange) && onTypeChange(e)
        updateCallManageState({
          callAllState: {...callFormData, searchType: e},
          currentPage: 1,
        })
      }}
    >
      <Option value="search">搜索</Option>
      {props.showCallOption ? <Option value="call">呼叫</Option> : null}
    </Select>
  )
  return (
    <div style={{display: 'flex', alignItems: 'center', borderRadius: '5px'}}>
      <Space.Compact>
        {selectBefore}
        <Input.Search
          disabled={callDisabled && type === 'call'}
          allowClear
          placeholder={placeholderList[type]}
          value={value}
          onChange={e => {
            const v = e.target.value
            setValue(v)
            isFunction(onChange) && onChange(v)
            updateCallManageState({
              currentPage: 1,
              callFormData: {...callFormData, searchKey: v},
            })
          }}
          enterButton={buttonText[type]}
          onSearch={(value, e, form) => {
            if (form?.source === 'clear') return

            if (type === 'search') {
              isFunction(onSearch) && onSearch({type, value})
              updateCallManageState({
                currentPage: 1,
                refreshList: !refreshList,
              })
            } else if (type === 'call') {
              isFunction(onCall) && onCall(value)
            }
          }}
        />
      </Space.Compact>
    </div>
  )
}
